import Vue from 'vue';
import { DateTimePicker } from './vue-drumroll-datetime-picker'

Vue.component('DateTimePicker', DateTimePicker);